// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ion-padding: 12px;
}

:host {
  --ion-background-color: var(--background-default);
}

ion-header {
  background: var(--ion-color-primary);
}

ion-item {
  position: relative;
  max-height: 42px;
  border: 0.8px solid rgba(197, 197, 197, 0.4784313725);
  border-radius: var(--radius-default);
  --background: transparent !important;
  overflow: visible;
}
ion-item.input-error {
  border: 0.8px solid #cc0e0e;
}
ion-item ion-input {
  font-family: AppFont, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 127%;
  --padding-start: 14px;
  color: var(--color-black);
}
ion-item:not(:has(ion-checkbox)) {
  display: flex;
  align-items: center;
}
ion-item:has(ion-checkbox) {
  border: none;
}
ion-item .input-error {
  border: 0.8px solid #cc0e0e;
}

.checkbox-item {
  display: flex;
  align-items: flex-start;
}
.checkbox-item ion-checkbox {
  --checkmark-color: #fff;
}

.din-pro-cond-med {
  margin-inline-start: 0;
  padding-top: 2px;
  font-family: AppFont;
  font-size: 10px;
  line-height: 16.9px;
  text-align: left;
  color: var(--color-black);
}

.underline {
  color: inherit;
  position: relative;
  z-index: 10;
}
.underline a {
  color: var(--ion-color-primary);
}

ion-slides {
  width: 100% !important;
  height: 100% !important;
}

ion-slide {
  width: 100% !important;
  --background: transparent;
}
ion-slide > ion-col {
  overflow: auto;
  top: 0;
  bottom: 0;
  position: absolute;
  text-align: left;
}

.phone-item {
  border: none;
}
.phone-item ion-input:first-child {
  margin-right: 10px;
}
.phone-item ion-input {
  margin-bottom: 5px;
}

ion-card {
  margin: 0;
  margin-bottom: 10px;
  padding: 0;
  text-align: initial;
  color: var(--color-black);
  overflow: auto;
  box-shadow: none;
  box-sizing: border-box;
}

.info-row:not(:last-child) {
  margin-bottom: 9px;
}

.left-col {
  padding: 0;
  padding-right: 5px;
  font-family: AppFont;
  font-size: 14px;
  line-height: 127%;
  font-weight: 400;
  color: var(--color-black);
}

.right-col {
  padding: 0;
  font-family: AppFont;
  font-size: 11px;
  line-height: 13.37px;
  text-align: right;
  color: var(--color-black);
}

.tip-sum {
  font-family: AppFont;
  font-size: 16px;
  line-height: 16.8px;
  text-align: right;
}

.item-row {
  margin-bottom: 10px;
}

.arcticle-name-col,
.article-price-col {
  padding: 0;
  margin-bottom: 5px;
  font-family: AppFont;
  font-size: 16px;
  line-height: 127%;
  color: var(--color-grey);
}

.article-price-col,
.option-price {
  font-family: AppFont;
  text-align: right !important;
}

.option-name,
.option-price {
  font-family: AppFont;
  font-size: 12px;
  line-height: 18.13px;
  text-align: left;
  color: var(--color-grey);
  padding-left: 10px;
}

.price-title,
.price-sum {
  margin: 0;
  font-family: AppFontMedium;
  font-size: 22px;
  line-height: 127%;
  color: var(--color-black);
  letter-spacing: 0em;
  text-transform: capitalize;
}

.price-content {
  padding-bottom: 0px;
}

.adds-price {
  font-family: AppFontMedium;
  color: var(--color-grey);
}

.price-sum {
  font-family: AppFontMedium;
  text-align: end;
}

ion-card-header {
  border-bottom: var(--outline-default);
  padding: 0px 0 12px;
  margin: 0 auto;
}
ion-card-header:last-of-type {
  border-top: var(--outline-default);
  padding-top: 12px;
  margin-top: 16px;
}
ion-card-header ion-button {
  --background: #f0f7f8;
  --color: black;
  border: 1.5px solid #f0f7f8;
  text-transform: none;
  height: 30px;
  width: 30px;
  --border-radius: 50%;
  box-shadow: none;
  border: none;
  --box-shadow: none;
}

ion-card-content {
  padding: 12px 0;
  margin: 0 auto;
}
.border-top-light-blue {
  border-top: 0.5px solid #e5e5e5;
}

ion-card-title {
  font-family: AppFontMedium;
  font-size: 22px;
  line-height: 127%;
  letter-spacing: -0.01em;
  text-align: left;
  color: var(--color-black);
}

ion-chip {
  margin: 0;
  padding: 0 6px;
  margin-left: auto;
  width: -moz-fit-content;
  width: fit-content;
  min-width: 36px;
  height: 26px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #785526;
  border-radius: var(--radius-default);
}
ion-chip ion-label {
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 16.2px;
  text-align: center;
  color: #fff;
}

.card-content-md {
  font-weight: unset;
}

.adds-price {
  padding-left: 5px;
}

.phone-block {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.phone-block ion-select {
  padding-bottom: 0;
  background: white;
  overflow: hidden;
  color: var(--ion-color-main);
  font-weight: 700;
  height: 68px;
  text-align: center;
  padding-top: 0;
  border-radius: 0px;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}
.phone-block ion-input {
  width: 70%;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}

.edit {
  display: flex;
  justify-content: flex-end;
}

.tip-row-text {
  margin-top: 8px;
}
.tip-row-text .left-col {
  font-size: 16px;
}

ion-footer {
  padding: 16px;
  --background: #fff;
  background: #fff !important;
  box-shadow: -3px -2px 8px 0px rgba(74, 103, 95, 0.0784313725);
  border-top: 1px solid #ded4c8;
}

.padding {
  padding: 22px;
}

.icon-edit {
  height: 30px;
  width: 30px;
}

.privacy-content {
  padding: 13px 12px 14px;
}

.privacy {
  margin: 12px 0 0;
  font-family: AppFont;
  font-size: 12px;
  line-height: 16.55px;
  text-align: center;
  color: var(--color-black);
}

.order-at-header {
  font-family: Capture;
  font-weight: normal;
  margin-top: 25px;
  color: var(--ion-color-secondary);
}

ion-checkbox {
  margin-left: 3px;
}

ion-checkbox {
  --background: transparent;
  --checkbox-background: transparent;
}

.sec-main-col {
  padding: 20px 16px;
}

.miles {
  border-top: 0.5px solid #311802;
  border-bottom: 0.5px solid #311802;
  margin: 12px 0;
  padding-inline: 12px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 100%;
}
.miles__img {
  width: 100px;
  height: 17px;
}
.miles__info {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.miles__info span {
  font-family: AppFontMediumAlt;
  font-size: 12px;
  line-height: 14.4px;
  color: #226086;
  width: 64%;
}
.miles__info.applied {
  width: 120px;
}
.miles__info.applied span {
  width: 100%;
}
.miles__icon {
  height: 20px;
  width: 20px;
}
.miles__icon.applied {
  height: 20px;
  width: 20px;
  flex-grow: 1;
}

.relative-block {
  position: relative;
}

.input-col {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.input-col:first-child {
  margin-bottom: 12px;
}
.input-col:has([name=email]) {
  margin-bottom: 25px;
}
.input-col ion-label {
  max-width: 50%;
  font-family: AppFont;
  font-size: 16px;
  line-height: 127%;
  text-transform: capitalize;
  color: var(--color-grey);
}

.table-chip {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 26px;
  min-width: 40px;
  padding-inline: 6px;
  background-color: #e1e6e2;
  border: 1px solid var(--ion-color-primary);
  border-radius: var(--radius-default);
  cursor: pointer;
  font-family: AppFontMedium;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-transform: capitalize;
  color: var(--ion-color-primary);
}
.table-chip ion-icon {
  --icon-color: var(--ion-color-primary);
  width: 10px;
}

.info-card-content {
  width: 100%;
  padding-block: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info-card-content ion-icon {
  height: 22px;
  width: 32px;
}
.info-card-content p {
  width: -moz-fit-content;
  width: fit-content;
  max-width: 91%;
  padding-inline: 10px;
  margin: 0;
  font-family: AppFontMedium;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 2%;
  text-align: start;
}

.info {
  background: #e1e6e2;
  color: var(--color-black);
  padding: 7px;
}
.info .info-icon-col {
  display: flex;
}
.info .info-icon-col ion-icon {
  width: 18px;
  height: 18px;
  --icon-color: var(--color-black);
}
.info p {
  color: var(--color-black);
  font-size: 10px;
  margin: 0;
}

.order-summary-card {
  border-bottom: var(--outline-default);
}

.error-text-block {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  transform: translate(0px, -10%);
}
.error-text-block.phone {
  bottom: -15px;
}
.error-text-block.agb {
  bottom: -10px;
}
.error-text-block .error-text {
  color: #bd3636;
  font-family: AppFont;
  font-weight: 400;
  font-size: 8px;
  line-height: 127%;
}

.privacy-checkbox {
  overflow: hidden;
}

.terms-block {
  margin-top: 12px;
  font-size: 12px;
  color: var(--color-grey);
  text-align: center;
}
.terms-block a {
  font-family: AppFontMedium;
  font-size: 12px;
  color: var(--color-grey);
}

.updated-price {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/checkout-modal/checkout-modal.component.scss"],"names":[],"mappings":"AAEA;EACC,mBAAA;AADD;;AAIA;EACC,iDAAA;AADD;;AAIA;EACC,oCAAA;AADD;;AAIA;EACC,kBAAA;EACA,gBAAA;EACA,qDAAA;EACA,oCAAA;EACA,oCAAA;EACA,iBAAA;AADD;AAEC;EACC,2BAAA;AAAF;AAGC;EACC,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;AADF;AAIC;EACC,aAAA;EACA,mBAAA;AAFF;AAKC;EACC,YAAA;AAHF;AAKC;EACC,2BAAA;AAHF;;AAOA;EACC,aAAA;EACA,uBAAA;AAJD;AAMC;EAEC,uBAAA;AALF;;AASA;EACC,sBAAA;EACA,gBAAA;EAEA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AAPD;;AAUA;EACC,cAAA;EACA,kBAAA;EACA,WAAA;AAPD;AASC;EACC,+BAAA;AAPF;;AAWA;EACC,sBAAA;EACA,uBAAA;AARD;;AAWA;EACC,sBAAA;EACA,yBAAA;AARD;AAUC;EACC,cAAA;EACA,MAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AARF;;AAYA;EACC,YAAA;AATD;AAUC;EACC,kBAAA;AARF;AAUC;EACC,kBAAA;AARF;;AAYA;EACC,SAAA;EACA,mBAAA;EACA,UAAA;EAMA,mBAAA;EACA,yBAAA;EACA,cAAA;EAEA,gBAAA;EACA,sBAAA;AAfD;;AAmBC;EACC,kBAAA;AAhBF;;AAoBA;EACC,UAAA;EACA,kBAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AAlBD;;AAqBA;EACC,UAAA;EAEA,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EAEA,yBAAA;AApBD;;AAuBA;EACC,oBAAA;EACA,eAAA;EACA,mBAAA;EAEA,iBAAA;AArBD;;AAwBA;EACC,mBAAA;AArBD;;AAwBA;;EAEC,UAAA;EACA,kBAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;AAtBD;;AAyBA;;EAEC,oBAAA;EACA,4BAAA;AAtBD;;AAyBA;;EAEC,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;AAtBD;;AA2BA;;EAEC,SAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0BAAA;AAxBD;;AA2BA;EACC,mBAAA;AAxBD;;AA2BA;EACC,0BAAA;EACA,wBAAA;AAxBD;;AA2BA;EACC,0BAAA;EACA,eAAA;AAxBD;;AA2BA;EAEC,qCAAA;EAEA,mBAAA;EACA,cAAA;AA1BD;AA4BC;EACC,kCAAA;EACA,iBAAA;EACA,gBAAA;AA1BF;AA6BC;EACC,qBAAA;EACA,cAAA;EACA,2BAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AA3BF;;AA+BA;EACC,eAAA;EACA,cAAA;AA5BD;AAmCA;EACC,+BAAA;AAjCD;;AAoCA;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EAEA,yBAAA;AAlCD;;AAqCA;EACC,SAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,oCAAA;AAnCD;AAoCC;EACC,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAlCF;;AAsCA;EACC,kBAAA;AAnCD;;AAsCA;EACC,iBAAA;AAnCD;;AAsCA;EACC,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAnCD;AAoCC;EACC,iBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,8BAAA;EACA,2BAAA;AAnCF;AAqCC;EACC,UAAA;EACA,8BAAA;EACA,2BAAA;AAnCF;;AAuCA;EACC,aAAA;EACA,yBAAA;AApCD;;AAuCA;EACC,eAAA;AApCD;AAsCC;EACC,eAAA;AApCF;;AAwCA;EACC,aAAA;EACA,kBAAA;EACA,2BAAA;EACA,6DAAA;EACA,6BAAA;AArCD;;AA2CA;EACC,aAAA;AAxCD;;AA0CA;EACC,YAAA;EACA,WAAA;AAvCD;;AA0CA;EACC,uBAAA;AAvCD;;AA0CA;EACC,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;AAvCD;;AA0CA;EACC,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;AAvCD;;AA0CA;EACC,gBAAA;AAvCD;;AA0CA;EACC,yBAAA;EACA,kCAAA;AAvCD;;AA0CA;EACC,kBAAA;AAvCD;;AA0CA;EACC,+BAAA;EACA,kCAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAvCD;AAyCC;EACC,YAAA;EACA,YAAA;AAvCF;AAyCC;EACC,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAvCF;AAwCE;EACC,6BAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;AAtCH;AAyCC;EACC,YAAA;AAvCF;AAyCE;EACC,WAAA;AAvCH;AA2CC;EACC,YAAA;EACA,WAAA;AAzCF;AA4CC;EACC,YAAA;EACA,WAAA;EACA,YAAA;AA1CF;;AA8CA;EACC,kBAAA;AA3CD;;AA8CA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AA3CD;AA8CC;EACC,mBAAA;AA5CF;AA+CC;EACC,mBAAA;AA7CF;AAgDC;EACC,cAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EAEA,0BAAA;EAEA,wBAAA;AAjDF;;AAqDA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EAEA,YAAA;EACA,eAAA;EACA,mBAAA;EAEA,yBAAA;EACA,0CAAA;EACA,oCAAA;EAEA,eAAA;EAEA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,0BAAA;EACA,+BAAA;AAtDD;AAwDC;EACC,sCAAA;EACA,WAAA;AAtDF;;AA0DA;EACC,WAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAvDD;AAyDC;EACC,YAAA;EACA,WAAA;AAvDF;AA0DC;EACC,uBAAA;EAAA,kBAAA;EACA,cAAA;EACA,oBAAA;EAEA,SAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAzDF;;AA4DA;EACC,mBAAA;EACA,yBAAA;EACA,YAAA;AAzDD;AA0DC;EACC,aAAA;AAxDF;AAyDE;EACC,WAAA;EACA,YAAA;EACA,gCAAA;AAvDH;AA0DC;EACC,yBAAA;EACA,eAAA;EACA,SAAA;AAxDF;;AA2DA;EACC,qCAAA;AAxDD;;AA0DA;EACC,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;AAvDD;AAyDC;EACC,aAAA;AAvDF;AAyDC;EACC,aAAA;AAvDF;AAyDC;EACC,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAvDF;;AA2DA;EACC,gBAAA;AAxDD;;AA2DA;EACC,gBAAA;EAEA,eAAA;EACA,wBAAA;EAEA,kBAAA;AA1DD;AA4DC;EACC,0BAAA;EACA,eAAA;EACA,wBAAA;AA1DF;;AA8DA;EACC,gBAAA;AA3DD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n:root {\n\t--ion-padding: 12px;\n}\n\n:host {\n\t--ion-background-color: var(--background-default);\n}\n\nion-header {\n\tbackground: var(--ion-color-primary);\n}\n\nion-item {\n\tposition: relative;\n\tmax-height: 42px;\n\tborder: 0.8px solid #c5c5c57a;\n\tborder-radius: var(--radius-default);\n\t--background: transparent !important;\n\toverflow: visible;\n\t&.input-error {\n\t\tborder: 0.8px solid #cc0e0e;\n\t}\n\n\tion-input {\n\t\tfont-family: AppFont, sans-serif;\n\t\tfont-weight: 400;\n\t\tfont-size: 14px;\n\t\tline-height: 127%;\n\t\t--padding-start: 14px;\n\t\tcolor: var(--color-black);\n\t}\n\n\t&:not(:has(ion-checkbox)) {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\n\t&:has(ion-checkbox) {\n\t\tborder: none;\n\t}\n\t.input-error {\n\t\tborder: 0.8px solid #cc0e0e;\n\t}\n}\n\n.checkbox-item {\n\tdisplay: flex;\n\talign-items: flex-start;\n\n\tion-checkbox {\n\t\t// margin-top: -3px;\n\t\t--checkmark-color: #fff;\n\t}\n}\n\n.din-pro-cond-med {\n\tmargin-inline-start: 0;\n\tpadding-top: 2px;\n\n\tfont-family: AppFont;\n\tfont-size: 10px;\n\tline-height: 16.9px;\n\ttext-align: left;\n\tcolor: var(--color-black);\n}\n\n.underline {\n\tcolor: inherit;\n\tposition: relative;\n\tz-index: 10;\n\n\ta {\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n\nion-slides {\n\twidth: 100% !important;\n\theight: 100% !important;\n}\n\nion-slide {\n\twidth: 100% !important;\n\t--background: transparent;\n\n\t> ion-col {\n\t\toverflow: auto;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tposition: absolute;\n\t\ttext-align: left;\n\t}\n}\n\n.phone-item {\n\tborder: none;\n\tion-input:first-child {\n\t\tmargin-right: 10px;\n\t}\n\tion-input {\n\t\tmargin-bottom: 5px;\n\t}\n}\n\nion-card {\n\tmargin: 0;\n\tmargin-bottom: 10px;\n\tpadding: 0;\n\n\t// background: #fff;\n\t// border: 1px solid #000000;\n\t// border-radius: var(--radius-default);\n\n\ttext-align: initial;\n\tcolor: var(--color-black);\n\toverflow: auto;\n\t// box-shadow: 0px 0px 15px 0px #7d5d281a;\n\tbox-shadow: none;\n\tbox-sizing: border-box;\n}\n\n.info-row {\n\t&:not(:last-child) {\n\t\tmargin-bottom: 9px;\n\t}\n}\n\n.left-col {\n\tpadding: 0;\n\tpadding-right: 5px;\n\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tline-height: 127%;\n\tfont-weight: 400;\n\tcolor: var(--color-black);\n}\n\n.right-col {\n\tpadding: 0;\n\n\tfont-family: AppFont;\n\tfont-size: 11px;\n\tline-height: 13.37px;\n\ttext-align: right;\n\n\tcolor: var(--color-black);\n}\n\n.tip-sum {\n\tfont-family: AppFont;\n\tfont-size: 16px;\n\tline-height: 16.8px;\n\t// letter-spacing: 0.07em;\n\ttext-align: right;\n}\n\n.item-row {\n\tmargin-bottom: 10px;\n}\n\n.arcticle-name-col,\n.article-price-col {\n\tpadding: 0;\n\tmargin-bottom: 5px;\n\n\tfont-family: AppFont;\n\tfont-size: 16px;\n\tline-height: 127%;\n\tcolor: var(--color-grey);\n}\n\n.article-price-col,\n.option-price {\n\tfont-family: AppFont;\n\ttext-align: right !important;\n}\n\n.option-name,\n.option-price {\n\tfont-family: AppFont;\n\tfont-size: 12px;\n\tline-height: 18.13px;\n\ttext-align: left;\n\tcolor: var(--color-grey);\n\tpadding-left: 10px;\n\n\t// text-transform: uppercase;\n}\n\n.price-title,\n.price-sum {\n\tmargin: 0;\n\tfont-family: AppFontMedium;\n\tfont-size: 22px;\n\tline-height: 127%;\n\tcolor: var(--color-black);\n\tletter-spacing: 0em;\n\ttext-transform: capitalize;\n}\n\n.price-content {\n\tpadding-bottom: 0px;\n}\n\n.adds-price {\n\tfont-family: AppFontMedium;\n\tcolor: var(--color-grey);\n}\n\n.price-sum {\n\tfont-family: AppFontMedium;\n\ttext-align: end;\n}\n\nion-card-header {\n\t// background: white;\n\tborder-bottom: var(--outline-default);\n\t// border-top: var(--outline-default);\n\tpadding: 0px 0 12px;\n\tmargin: 0 auto;\n\n\t&:last-of-type {\n\t\tborder-top: var(--outline-default);\n\t\tpadding-top: 12px;\n\t\tmargin-top: 16px;\n\t}\n\n\tion-button {\n\t\t--background: #f0f7f8;\n\t\t--color: black;\n\t\tborder: 1.5px solid #f0f7f8;\n\t\ttext-transform: none;\n\t\theight: 30px;\n\t\twidth: 30px;\n\t\t--border-radius: 50%;\n\t\tbox-shadow: none;\n\t\tborder: none;\n\t\t--box-shadow: none;\n\t}\n}\n\nion-card-content {\n\tpadding: 12px 0;\n\tmargin: 0 auto;\n\n\t&:not(:last-child) {\n\t\t// border-bottom: 0.5px solid #a2834f;\n\t}\n}\n\n.border-top-light-blue {\n\tborder-top: 0.5px solid #e5e5e5;\n}\n\nion-card-title {\n\tfont-family: AppFontMedium;\n\tfont-size: 22px;\n\tline-height: 127%;\n\tletter-spacing: -0.01em;\n\ttext-align: left;\n\n\tcolor: var(--color-black);\n}\n\nion-chip {\n\tmargin: 0;\n\tpadding: 0 6px;\n\tmargin-left: auto;\n\twidth: fit-content;\n\tmin-width: 36px;\n\theight: 26px !important;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\tbackground: #785526;\n\tborder-radius: var(--radius-default);\n\tion-label {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 14px;\n\t\tline-height: 16.2px;\n\t\ttext-align: center;\n\t\tcolor: #fff;\n\t}\n}\n\n.card-content-md {\n\tfont-weight: unset;\n}\n\n.adds-price {\n\tpadding-left: 5px;\n}\n\n.phone-block {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tion-select {\n\t\tpadding-bottom: 0;\n\n\t\tbackground: white;\n\t\toverflow: hidden;\n\t\tcolor: var(--ion-color-main);\n\t\tfont-weight: 700;\n\t\theight: 68px;\n\t\ttext-align: center;\n\t\tpadding-top: 0;\n\t\tborder-radius: 0px;\n\t\tborder-bottom-left-radius: 0px;\n\t\tborder-top-left-radius: 0px;\n\t}\n\tion-input {\n\t\twidth: 70%;\n\t\tborder-bottom-left-radius: 0px;\n\t\tborder-top-left-radius: 0px;\n\t\t// padding: 8px 0px 8px 0px !important;\n\t}\n}\n.edit {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n}\n\n.tip-row-text {\n\tmargin-top: 8px;\n\n\t.left-col {\n\t\tfont-size: 16px;\n\t}\n}\n\nion-footer {\n\tpadding: 16px;\n\t--background: #fff;\n\tbackground: #fff !important;\n\tbox-shadow: -3px -2px 8px 0px #4a675f14;\n\tborder-top: 1px solid #ded4c8;\n\n\t// &:has(.tip-row) {\n\t// \tbox-shadow: -5px 0px 56px 0px #00000017;\n\t// }\n}\n.padding {\n\tpadding: 22px;\n}\n.icon-edit {\n\theight: 30px;\n\twidth: 30px;\n}\n\n.privacy-content {\n\tpadding: 13px 12px 14px;\n}\n\n.privacy {\n\tmargin: 12px 0 0;\n\tfont-family: AppFont;\n\tfont-size: 12px;\n\tline-height: 16.55px;\n\ttext-align: center;\n\tcolor: var(--color-black);\n}\n\n.order-at-header {\n\tfont-family: Capture;\n\tfont-weight: normal;\n\tmargin-top: 25px;\n\tcolor: var(--ion-color-secondary);\n}\n\nion-checkbox {\n\tmargin-left: 3px;\n}\n\nion-checkbox {\n\t--background: transparent;\n\t--checkbox-background: transparent;\n}\n\n.sec-main-col {\n\tpadding: 20px 16px;\n}\n\n.miles {\n\tborder-top: 0.5px solid #311802;\n\tborder-bottom: 0.5px solid #311802;\n\tmargin: 12px 0;\n\tpadding-inline: 12px;\n\tbackground-color: #ffffff;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 50px;\n\twidth: 100%;\n\n\t&__img {\n\t\twidth: 100px;\n\t\theight: 17px;\n\t}\n\t&__info {\n\t\tflex-grow: 1;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tspan {\n\t\t\tfont-family: AppFontMediumAlt;\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 14.4px;\n\t\t\tcolor: #226086;\n\t\t\twidth: 64%;\n\t\t}\n\t}\n\t&__info.applied {\n\t\twidth: 120px;\n\n\t\tspan {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t&__icon {\n\t\theight: 20px;\n\t\twidth: 20px;\n\t}\n\n\t&__icon.applied {\n\t\theight: 20px;\n\t\twidth: 20px;\n\t\tflex-grow: 1;\n\t}\n}\n\n.relative-block {\n\tposition: relative;\n}\n\n.input-col {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\t// margin-bottom: 16px;\n\n\t&:first-child {\n\t\tmargin-bottom: 12px;\n\t}\n\n\t&:has([name='email']) {\n\t\tmargin-bottom: 25px;\n\t}\n\n\tion-label {\n\t\tmax-width: 50%;\n\n\t\tfont-family: AppFont;\n\t\tfont-size: 16px;\n\t\tline-height: 127%;\n\t\t// letter-spacing: 0.01em;\n\t\ttext-transform: capitalize;\n\n\t\tcolor: var(--color-grey);\n\t}\n}\n\n.table-chip {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 8px;\n\n\theight: 26px;\n\tmin-width: 40px;\n\tpadding-inline: 6px;\n\n\tbackground-color: #e1e6e2;\n\tborder: 1px solid var(--ion-color-primary);\n\tborder-radius: var(--radius-default);\n\n\tcursor: pointer;\n\n\tfont-family: AppFontMedium;\n\tfont-size: 16px;\n\tline-height: 100%;\n\tletter-spacing: 0.02em;\n\tvertical-align: middle;\n\ttext-transform: capitalize;\n\tcolor: var(--ion-color-primary);\n\n\tion-icon {\n\t\t--icon-color: var(--ion-color-primary);\n\t\twidth: 10px;\n\t}\n}\n\n.info-card-content {\n\twidth: 100%;\n\tpadding-block: 12px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\tion-icon {\n\t\theight: 22px;\n\t\twidth: 32px;\n\t}\n\n\tp {\n\t\twidth: fit-content;\n\t\tmax-width: 91%;\n\t\tpadding-inline: 10px;\n\n\t\tmargin: 0;\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 12px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 2%;\n\t\ttext-align: start;\n\t}\n}\n.info {\n\tbackground: #e1e6e2;\n\tcolor: var(--color-black);\n\tpadding: 7px;\n\t.info-icon-col {\n\t\tdisplay: flex;\n\t\tion-icon {\n\t\t\twidth: 18px;\n\t\t\theight: 18px;\n\t\t\t--icon-color: var(--color-black);\n\t\t}\n\t}\n\tp {\n\t\tcolor: var(--color-black);\n\t\tfont-size: 10px;\n\t\tmargin: 0;\n\t}\n}\n.order-summary-card {\n\tborder-bottom: var(--outline-default);\n}\n.error-text-block {\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttop: 100%;\n\ttransform: translate(0px, -10%);\n\n\t&.phone {\n\t\tbottom: -15px;\n\t}\n\t&.agb {\n\t\tbottom: -10px;\n\t}\n\t.error-text {\n\t\tcolor: #bd3636;\n\t\tfont-family: AppFont;\n\t\tfont-weight: 400;\n\t\tfont-size: 8px;\n\t\tline-height: 127%;\n\t}\n}\n\n.privacy-checkbox {\n\toverflow: hidden;\n}\n\n.terms-block {\n\tmargin-top: 12px;\n\n\tfont-size: 12px;\n\tcolor: var(--color-grey);\n\n\ttext-align: center;\n\n\ta {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 12px;\n\t\tcolor: var(--color-grey);\n\t}\n}\n\n.updated-price {\n\tmargin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
